import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

export default function SettingsPanel({ canEditAll = true }) {
  const [s, setS] = useState(null);

  useEffect(() => { api.get("/admin/settings").then((r) => setS(r.data)).catch(() => {}); }, []);

  const patch = async (updates) => {
    try {
      const { data } = await api.patch("/admin/settings", updates);
      setS(data);
      toast.success("Saved");
    } catch (e) { toast.error("Save failed"); }
  };

  if (!s) return <p className="text-stone-500">Loading…</p>;

  return (
    <div className="max-w-2xl space-y-6">
      <div className="rounded-2xl border border-stone-200 bg-white p-6">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="font-display text-lg font-bold text-stone-900">Pause Online Ordering</h3>
            <p className="text-sm text-stone-600">Temporarily stop new orders during rush periods.</p>
          </div>
          <Switch data-testid="admin-toggle-ordering-pause-switch" checked={s.ordering_paused} onCheckedChange={(v) => patch({ ordering_paused: v })} />
        </div>
        {s.ordering_paused && <div className="mt-3 rounded-lg bg-amber-100 px-3 py-2 text-sm font-semibold text-amber-900">Ordering is currently PAUSED.</div>}
      </div>

      {canEditAll && (
        <div className="rounded-2xl border border-stone-200 bg-white p-6">
          <h3 className="font-display text-lg font-bold text-stone-900">Restaurant Details</h3>
          <div className="mt-4 space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div><Label>Tax rate (e.g. 0.065)</Label><Input type="number" step="0.001" defaultValue={s.tax_rate} onBlur={(e) => patch({ tax_rate: Number(e.target.value) })} className="mt-1.5" /></div>
              <div><Label>Phone</Label><Input defaultValue={s.phone} onBlur={(e) => patch({ phone: e.target.value })} className="mt-1.5" /></div>
            </div>
            <div><Label>Address</Label><Input defaultValue={s.address} onBlur={(e) => patch({ address: e.target.value })} className="mt-1.5" /></div>
            <div><Label>Contact email</Label><Input defaultValue={s.email} onBlur={(e) => patch({ email: e.target.value })} className="mt-1.5" /></div>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
              <div><Label>Instagram URL</Label><Input data-testid="admin-instagram-input" defaultValue={s.instagram} onBlur={(e) => patch({ instagram: e.target.value })} placeholder="https://instagram.com/…" className="mt-1.5" /></div>
              <div><Label>Facebook URL</Label><Input data-testid="admin-facebook-input" defaultValue={s.facebook} onBlur={(e) => patch({ facebook: e.target.value })} placeholder="https://facebook.com/…" className="mt-1.5" /></div>
              <div><Label>TikTok URL</Label><Input data-testid="admin-tiktok-input" defaultValue={s.tiktok} onBlur={(e) => patch({ tiktok: e.target.value })} placeholder="https://tiktok.com/@…" className="mt-1.5" /></div>
            </div>
            <div><Label>Story</Label><Textarea defaultValue={s.story} onBlur={(e) => patch({ story: e.target.value })} className="mt-1.5 resize-none" rows={4} /></div>
            <p className="text-xs text-stone-400">Changes save when you click away from a field.</p>
          </div>
        </div>
      )}
    </div>
  );
}
